// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2Dq2h";
var _4 = "title-1InVC";
var _5 = "message-1sh74";
var _6 = "row-3fF3D";
var _7 = "input_wrapper-vpmIM";
var _8 = "button_wrapper-1pEwk";
var _9 = "codeInfo-2bXax";
var _a = "resend-1EOdp";
var _b = "resend__label-24CYP";
var _c = "passwordAdornment-2gGo8";
var _d = "active-1I5GM";
var _e = "input-2XpO8";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "title", _5 as "message", _6 as "row", _7 as "input_wrapper", _8 as "button_wrapper", _9 as "codeInfo", _a as "resend", _b as "resend__label", _c as "passwordAdornment", _d as "active", _e as "input" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "title": _4, "message": _5, "row": _6, "input_wrapper": _7, "button_wrapper": _8, "codeInfo": _9, "resend": _a, "resend__label": _b, "passwordAdornment": _c, "active": _d, "input": _e }
